import { BasketLine } from '@models/api-orders.models';
import { mapToBasketTrackableProduct } from '@utils/gtm-tracking/utils/mapToBasketTrackableProduct';
import { Product } from '@utils/gtm-tracking/model/Product';

export type ShippingInfoEventStore = {
    store_name: string;
    store_id: string;
};

export type AddShippingInfoEvent = {
    event: 'add_shipping_info';
    ecommerce: {
        currency: string;
        value: number;
        coupon?: string;
        shipping_tier: string;
        shipping_provider?: string;
        selected_store?: ShippingInfoEventStore;
        items: Product[];
    };
};

export const trackAddShippingInfoEvent = (
    products: BasketLine[],
    basketValue: number = 0,
    coupon: string[] = [],
    shippingProvider: string,
    shippingTier: string,
    store?: ShippingInfoEventStore,
    currency: string = 'DKK'
): AddShippingInfoEvent => ({
    event: 'add_shipping_info',
    ecommerce: {
        currency,
        value: basketValue,
        coupon: coupon.join(', '),
        shipping_tier: shippingTier,
        /*
        // temporarily commented, until they need this, because they will
            shipping_provider: shippingProvider,
        ...(store ? { selected_store: store } : {}),
        */
        items: products.map(product => mapToBasketTrackableProduct(product))
    }
});
